<template>
  <div class="layout-publico">
    <v-card elevation="4" class="layout-publico__cartao" :max-width="larguraMaxima">
      <!-- Cabeçalho na cor primária, a mesma das abas, com a logo num selo branco -->
      <div class="layout-publico__cabecalho primary white--text">
        <div class="layout-publico__selo">
          <img src="/img/logo2.png" alt="Logo da escola" />
        </div>
        <div>
          <h1 class="text-h5 font-weight-bold">{{ titulo }}</h1>
          <p class="text-body-2 mb-0 layout-publico__subtitulo">{{ subtitulo }}</p>
        </div>
      </div>
      <!-- A rolagem fica aqui dentro: a página não rola, o cabeçalho continua visível. -->
      <v-card-text class="layout-publico__conteudo">
        <slot />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
/**
 * Moldura das telas públicas da pré-matrícula. Não usa o main-template, que depende de usuário
 * logado (menu, ano letivo, caixa).
 */
export default {
  name: "ELayoutPublico",
  props: {
    titulo: { type: String, required: true },
    subtitulo: { type: String, default: "Colégio Logos" },
    larguraMaxima: { type: [Number, String], default: 600 },
  },
};
</script>

<style scoped>
.layout-publico {
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../../assets/background_tratato_para_web.jpg");
  background-size: cover;
}

.layout-publico__cartao {
  width: 100%;
  max-height: 100%;
  overflow: hidden; /* cabeçalho acompanha os cantos arredondados do cartão */
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.layout-publico__cabecalho {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 20px 24px;
}

.layout-publico__selo {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.layout-publico__selo img {
  width: 60px;
}

.layout-publico__subtitulo {
  opacity: 0.85;
}

.layout-publico__conteudo {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-top: 16px !important;
}

@media (max-width: 600px) {
  .layout-publico {
    padding: 0;
  }

  .layout-publico__cartao {
    height: 100%;
    border-radius: 0 !important;
  }

  .layout-publico__cabecalho {
    padding: 16px;
  }

  .layout-publico__selo {
    width: 56px;
    height: 56px;
  }

  .layout-publico__selo img {
    width: 46px;
  }
}
</style>
